import { regexOnlyNumber } from 'shell/constants/regex';
import * as yup from 'yup';

export const validationSchemaRequestMunicipalNumber = yup.object().shape({
  numberElement: yup
    .string()
    .nullable()
    .required('Campo obbligatorio')
    .matches(regexOnlyNumber, 'Campo numerico'),
  year: yup
    .string()
    .nullable()
    .required('Campo obbligatorio')
    .matches(regexOnlyNumber, 'Campo numerico'),
});
